// This is the determining ID for the many module federation apps that Link has.
export const APP_NAME = 'auth';
